import CompanySaga from "./saga";
import companyOperationSaga from "./company-operation.saga";

export default [CompanySaga, companyOperationSaga];
